import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  sectionIntro: ".animation--section-introduction > *",
};

export default node => {
  if (!shouldAnimate(node)) return;

  delayOffset(node, [selectors.sectionIntro]);

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
